var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import React, { Fragment } from 'react';
import { ColumnLink, StyledColumn, StyledNav, Title, ColumnSubLink, StyledColumnItem } from './NavigationColumns.styles';
import DataPresenter from '../../data-presenter';

var NavigationColumns = function NavigationColumns(_a) {
  var columns = _a.columns,
      linkComponent = _a.linkComponent,
      isLoading = _a.isLoading;
  return /*#__PURE__*/React.createElement(StyledNav, null, isLoading || !columns ? [1, 2, 3, 4, 5, 6].map(function (column) {
    return /*#__PURE__*/React.createElement(StyledColumn, {
      key: column,
      "data-test": 'footer-column',
      "data-gtm": 'footer-column'
    }, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(DataPresenter, {
      nodata: true,
      loading: isLoading,
      width: 10,
      height: 1
    })), [1, 2, 3, 4, 5].map(function (link) {
      return /*#__PURE__*/React.createElement(Fragment, {
        key: link
      }, /*#__PURE__*/React.createElement(ColumnLink, {
        key: link,
        "data-test": 'footer-column-link',
        href: '#'
      }, /*#__PURE__*/React.createElement(DataPresenter, {
        nodata: true,
        loading: isLoading,
        width: 15,
        height: 1
      })), link === 5 ? [1, 2, 3].map(function (subL, i) {
        return /*#__PURE__*/React.createElement(ColumnSubLink, {
          key: subL || i,
          "data-test": 'footer-column-sublink',
          href: '#'
        }, /*#__PURE__*/React.createElement(DataPresenter, {
          nodata: true,
          loading: isLoading,
          width: 15,
          height: 1
        }));
      }) : null);
    }));
  }) : columns.map(function (column) {
    return /*#__PURE__*/React.createElement(StyledColumn, {
      key: column.id,
      "data-test": 'footer-column',
      "data-gtm": 'footer-column'
    }, column.columnItems.map(function (cItem) {
      return /*#__PURE__*/React.createElement(StyledColumnItem, {
        key: cItem.id,
        "data-test": 'footer-column-item',
        "data-gtm": 'footer-column-item'
      }, /*#__PURE__*/React.createElement(Title, null, cItem.title), cItem.links.map(function (link) {
        var _a;

        var linkTestProps = {
          'data-test': 'footer-column-link'
        };
        var subLinkTestProps = {
          'data-test': 'footer-column-link'
        };
        var Comp = linkComponent;
        var Component = /*#__PURE__*/React.createElement(Comp, {
          href: '#',
          to: '#'
        });

        if (Component.type.displayName === 'SmartLink') {
          // React Router complains about dataTest
          // So exclude it unless used by SmartLink
          linkTestProps.dataTest = 'footer-column-link';
          subLinkTestProps.dataTest = 'footer-column-sublink';
        }

        return /*#__PURE__*/React.createElement(Fragment, {
          key: link.id
        }, /*#__PURE__*/React.createElement(ColumnLink, __assign({
          as: linkComponent,
          key: link.id,
          href: link.link,
          to: link.link,
          disabled: ((_a = link.subLinks) === null || _a === void 0 ? void 0 : _a.length) > 0
        }, linkTestProps), link.label), link.subLinks && link.subLinks.length > 0 ? link.subLinks.map(function (sublink, i) {
          return /*#__PURE__*/React.createElement(ColumnSubLink, __assign({
            as: linkComponent,
            key: sublink.id || i,
            href: sublink.link,
            to: sublink.link
          }, subLinkTestProps), sublink.label);
        }) : null);
      }));
    }));
  }));
};

export default NavigationColumns;